<template>
  <div style="width: 100%">
    <audio-player
      ref="audioPlayer"
      :audio-list="audioList.map((elm) => elm.url)"
      :before-play="handleBeforePlay"
      theme-color="#38443C"
      :show-playback-rate="false"
      :show-volume-button="false"
      :show-next-button="false"
      :show-prev-button="false"
      :show-play-button="false"
    />
    <div class="d-flex align-center justify-center mt-5">
      <button @click="onDecrement()">
        <img src="@/assets/icons/-10_.svg" style="height: 25px; width: auto" />
      </button>
      <button @click="onPlay()" class="mx-6">
        <img
          v-if="!isPlaying"
          src="@/assets/icons/play.svg"
          style="height: 60px; width: auto"
        />
        <img
          v-else
          src="@/assets/icons/pause.svg"
          style="height: 60px; width: auto"
        />
      </button>
      <button @click="onIncrement()">
        <img src="@/assets/icons/+10_.svg" style="height: 25px; width: auto" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    audioFile: Array,
  },

  created() {
    console.log(this.mobileLang.code, "mobile Lang");
    this.audioList.push({
      name: "audiofile",
      url: `https://chalkidiki.mobics.gr/sound/${
        this.audioFile[0].sound.file_name.split(".")[0]
      }${
        this.mobileLang.code == "en"
          ? "-en." + this.audioFile[0].sound.file_name.split(".")[1]
          : "." + this.audioFile[0].sound.file_name.split(".")[1]
      }`,
    });
    console.log(this.audioList);
  },

  mounted() {
    this.$nextTick(() => {
      this.audio = this.$refs.audioPlayer.$refs.audio;
      this.audio.onended = async () => {
        this.end = true;
      };
    });
  },

  data() {
    return {
      ended: false,
      audio: null,
      playedOnce: false,
      isPlaying: false,
      audioList: [],
    };
  },

  computed: {
    ...mapState({
      mobileLang: (state) => state.base.mobileLang,
    }),
  },

  methods: {
    onIncrement() {
      this.audio.currentTime += 10;
      console.log();
    },

    onDecrement() {
      this.audio.currentTime -= 10;
    },

    async onPlay() {
      this.end = false;
      if (this.isPlaying) {
        await this.$refs.audioPlayer.pause();

        this.isPlaying = !this.isPlaying;
        return;
      } else {
        await this.$refs.audioPlayer.play();
        this.isPlaying = !this.isPlaying;
        return;
      }
    },
    // Something to do before playing
    handleBeforePlay(next) {
      if (this.end) {
        this.audio.currentTime = 0;
        this.$refs.audioPlayer.pause();
        this.isPlaying = !this.isPlaying;

        return;
      }
      // There are a few things you can do here...
      next(); // Start playing
    },
  },
};
</script>

<style lang="scss">
.audio-player {
  width: 100%;
}
.audio__play-loading {
  display: none !important;
}
.audio-player .audio__progress {
  border-radius: 0 !important;
  z-index: 0 !important;
}

.audio-player .audio__progress-wrap {
  background: transparent !important;
  border: 1px solid black;
  padding: 3px;
  border-radius: 0 !important;
  z-index: 0 !important;
  min-width: 100%;
}

.audio__progress-point {
  box-shadow: none !important;
  background: transparent !important;
  z-index: 0 !important;
}

.audio__progress-point::after {
  box-shadow: none !important;
  background: transparent !important;
  z-index: 0 !important;
}

.audio__time-wrap {
  transition: all 1s ease;

  .audio__current-time {
    font-weight: 250;
    color: #333333;
    font-size: 16px !important;
  }

  .audio__duration {
    font-weight: 250;
    color: #333333;
    font-size: 16px !important;
  }
}
</style>
